import { useEffect, useState } from 'react';
import { api } from './api';

// Bulk voucher discovery untuk listing — SATU request per halaman (anti N+1 per ProductCard).
// Cache module-scope: dedupe lintas instance/remount (StrictMode, multi-section grid).
// Return Set berisi product_id yang punya voucher discoverable untuk user saat ini.
const _voucherCache = {};

export function useVoucherMap(products) {
  const [map, setMap] = useState(() => new Set());
  const ids = (products || []).map((p) => p.product_id).join(',');
  useEffect(() => {
    if (!ids) { setMap(new Set()); return; }
    if (_voucherCache[ids]) { setMap(_voucherCache[ids]); return; }
    let active = true;
    api.get('/vouchers/product-map', { params: { product_ids: ids } })
      .then((r) => {
        const s = new Set(r.data.product_ids || []);
        _voucherCache[ids] = s;
        if (active) setMap(s);
      })
      .catch(() => {});
    return () => { active = false; };
  }, [ids]);
  return map;
}

// Render-prop wrapper agar halaman listing cukup 1 edit di titik grid (tanpa ubah head komponen):
// <VoucherBadges products={list}>{(map) => list.map((p) => <ProductCard ... hasVoucher={map.has(p.product_id)} />)}</VoucherBadges>
export function VoucherBadges({ products, children }) {
  const map = useVoucherMap(products);
  return children(map);
}
